import React from 'react';
import { Form, Card, Button } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateExamWithTestsDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface Props {
  prevStep?: () => void;
  nextStep?: () => void;
  handleFormData?: (input: string) => (e: string | boolean | Date) => void;
  sportsClubName?: string;
  sportsClubAddress?: string;
  sportsDiscipline?: string;
  propertyChange?: (obj: Partial<CreateUpdateExamWithTestsDto>) => void;
}

export const AddSport: React.FC<Props> = ({
  prevStep,
  nextStep,
  handleFormData,
  sportsClubName,
  sportsClubAddress,
  sportsDiscipline,
  propertyChange,
}) => {
  const handleOnNext = () => {
    if (nextStep) {
      nextStep();
    }
  };

  const handleOnPrev = () => {
    if (prevStep) {
      prevStep();
    }
  };

  const propertyChangeWithHandleFormData = (
    field: string,
    checked: boolean | string | Date,
  ) => {
    if (handleFormData) {
      handleFormData(field)(checked);
    }
    if (propertyChange) {
      propertyChange({ [field]: checked });
    }
  };

  return (
    <>
      <Card>
        <Card.Body>
          <Card.Subtitle className="mb-4">Sport</Card.Subtitle>
          <Form className="d-grid gap-3">
            <FormRow controlId="sportsClubName" label="Nazwa klubu">
              <Form.Control
                as="textarea"
                rows={3}
                value={sportsClubName || ''}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'sportsClubName',
                    e.target.value,
                  )
                }
              />
            </FormRow>
            <FormRow controlId="sportsClubAddress" label="Adres klubu">
              <Form.Control
                as="textarea"
                rows={3}
                value={sportsClubAddress || ''}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'sportsClubAddress',
                    e.target.value,
                  )
                }
              />
            </FormRow>
            <FormRow controlId="sportsDiscipline" label="Dyscyplina sportowa">
              <Form.Control
                as="textarea"
                rows={3}
                value={sportsDiscipline || ''}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'sportsDiscipline',
                    e.target.value,
                  )
                }
              />
            </FormRow>

            {prevStep && nextStep && (
              <div className="d-flex justify-content-end m-3">
                <Button
                  variant="outline-secondary"
                  className="ms-1"
                  onClick={handleOnPrev}
                >
                  Wstecz
                </Button>

                <Button
                  variant="outline-primary"
                  className="ms-1"
                  onClick={handleOnNext}
                >
                  Dalej
                </Button>
              </div>
            )}
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
